const verification_code = {
    phone_email_empty: 'هم تلفن و هم ایمیل خالی هستند.',
    not_found: 'کد تأیید یافت نشد. لطفاً ابتدا کد تأیید ارسال کنید.',
    phone_mismatch: 'تلفن مطابقت ندارد. لطفاً کد تأیید جدید درخواست کنید.',
    email_mismatch: 'ایمیل مطابقت ندارد. لطفاً کد تأیید جدید درخواست کنید.',
    code_mismatch: 'کد تأیید نامعتبر است.',
    expired: 'کد تأیید منقضی شده است. لطفاً کد تأیید جدید درخواست کنید.',
    exceed_max_try: 'محدودیت تلاش مجدد کد تأیید تجاوز شد. لطفاً کد تأیید جدید درخواست کنید.',
};
export default Object.freeze(verification_code);
